import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['entries', 'pagination', 'spinner'];

  initialize() {
    $("#update-list-form").hide();
    let options = {
      rootMargin: '200px',
    };

    this.intersectionObserver = new IntersectionObserver(entries => this.processIntersectionEntries(entries), options);
  }

  getLatestPosts(event) {
    this.loader($(event.target));
    $(event.target).addClass('disabled');
  }

  handleFollow(event) {
    this.loader($(event.target).parent());
  }

  shareList(event) {
    $("input[name=list_id]").val($(event.target).data('id'));
    $("input[name=user_ids]").val(null).trigger('change');
    $("input[name=editable]").prop("checked", false);
    $("#share-list-modal").modal('show');
  }

  loader(ele, append = false) {
    var loadingText = $('<span class="text-primary"><i class="fa fa-circle-o-notch fa-spin"></i></span>');
    (append == true) ? ele.append(loadingText) : ele.html(loadingText);
  }

  manageUpdate(event) {
    this.loader($(event.target).parent(), true);
    $(event.target).parent().addClass('disabled');
    $(event.target).hide();
  }

  toggleForm() {
    $("#update-list-form").toggle();
  }

  connect() {
    this.intersectionObserver.observe(this.paginationTarget);
    $(this.spinnerTarget).hide();

    // If this is a chart page
    // this.chart = Chartkick.charts['topic-analytics'];
    // this.barClickHandler();

  }

  disconnect() {
    this.intersectionObserver.unobserve(this.paginationTarget);
  }

  processIntersectionEntries(entries) {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        this.loadMore();
      }
    });
  }

  loadMore() {
    let next_page = this.paginationTarget.querySelector("a[rel='next']");
    if(next_page == null) return;
    let url = next_page.href;
    $(this.spinnerTarget).show();
    Rails.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      success: (response) => {
        this.entriesTarget.insertAdjacentHTML('beforeend', response.entries);
        this.paginationTarget.innerHTML = response.pagination;
        $(this.spinnerTarget).hide();
      }
    });
  }

  checkTelegramAccExisted(event) {
    var id = $(event.target).attr('id');
    var platform = $('#' + id +' :selected').text().toLowerCase();
    if(platform == 'telegram') {
      Rails.ajax({
        type: 'GET',
        url: '/telegram_accounts/total_accounts',
        dataType: 'json',
        success: (response) => {
          if(response.accounts < 1) {
            window.location.href = '/telegram_accounts';
          }
        }
      });
    }
  }

  AddToList(event){
    event.preventDefault();
    var id = $(event.target).attr('id');
    if (confirm('Are You Sure?')){
      var data = new FormData();
      data.append("list_id", id);

      var checked_ids = $(".channel-checkbox:checked").map(function(id, elem) { return $(elem).attr("id")})

      var channel_id = $(event.target).data('channel-id');
      if(channel_id) checked_ids.push(channel_id) 

      data.append("channel_ids", checked_ids.toArray());

      Rails.ajax({
        type: 'POST',
        url: '/lists/add_channels',
        data: data,
        dataType: 'json',
        success: (response) => {
          $(".channel-update-menu .checkbox-li").find(`a#${id}`).remove();
          alert(response.notice)
        },
        error: (response) => {
          alert(response.alert)
        }
      });
    }
    else {
      return false;
    }
  }

  showExportModal(event) {
    var id = $(event.target).data('list');
    $('#csvExportModal').modal('toggle');
    $("#extraParams").val(`list=${id}`)
  }

  viewFilter(event){
    let params = new URLSearchParams(window.location.search)
    params.set('view_as', event.target.value);
    window.location.href = window.location.href.split('?')[0] + '?' + params
  }
}